import type { SocialPostPreviewCardMetadata } from '@wix/ai-scheduling-assistant-common-lib/entities';

export const TIKTOK_CAPTION_LIMIT = 60;
export const TIKTOK_DOTS = 4;

export type TiktokLook = 'tiktok-video' | 'tiktok-photo';

export function tiktokLook(card: Pick<SocialPostPreviewCardMetadata, 'media'>): TiktokLook | undefined {
  const { media } = card;
  if (media.length === 1 && media[0].kind === 'video') {
    return 'tiktok-video';
  }
  if (media.length > 0 && media.every((item) => item.kind === 'image')) {
    return 'tiktok-photo';
  }
  return undefined;
}

export function tiktokDots(total: number, index: number): { count: number; active: number } {
  return { count: Math.min(total, TIKTOK_DOTS), active: Math.min(index, TIKTOK_DOTS - 1) };
}
